import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { ApiSuccess, CompanyProfileSettingInput, CompanyProfileSettingView } from '@app/shared';
import { apiClient } from '../../lib/api-client';

const KEY = ['settings', 'company-profile'];

export function useCompanyProfileSetting() {
  return useQuery({
    queryKey: KEY,
    queryFn: async (): Promise<CompanyProfileSettingView> => {
      const res = await apiClient.get<ApiSuccess<CompanyProfileSettingView>>(
        '/settings/company-profile',
      );
      return res.data.data;
    },
  });
}

export function useUpdateCompanyProfile() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (input: CompanyProfileSettingInput): Promise<CompanyProfileSettingView> => {
      const res = await apiClient.put<ApiSuccess<CompanyProfileSettingView>>(
        '/settings/company-profile',
        input,
      );
      return res.data.data;
    },
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: KEY });
      /*
       * 文件抬頭走的是另一支端點(`GET /accounting/company-profile`,見
       * `features/accounting/api.ts` 的 `useCompanyProfile()`),而且快取 5 分鐘 ——
       * 不一起失效的話,管理員存完設定回去列印,抬頭還是舊的。
       */
      void qc.invalidateQueries({ queryKey: ['accounting', 'company-profile'] });
    },
  });
}
